module.exports = __webpack_public_path__ + "static/media/checked.408bbec6.svg";